type Props = {
  previewContent: string
}

export default function SignaturePreviewContent({ previewContent }: Props) {
  return (
    <div className="signature-preview">
      <div className="signature-preview__skeleton">
        <div className="signature-preview__skeleton-line signature-preview__skeleton-line--wide" />
        <div className="signature-preview__skeleton-line signature-preview__skeleton-line--medium" />
        <div className="signature-preview__skeleton-line signature-preview__skeleton-line--narrow" />
        <div className="signature-preview__skeleton-line signature-preview__skeleton-line--wide" />
        <div className="signature-preview__skeleton-line signature-preview__skeleton-line--medium" />
      </div>

      {previewContent ? (
        <div
          className="mt-4"
          dangerouslySetInnerHTML={{ __html: previewContent }}
        />
      ) : (
        <div className="mt-4 text-muted">
          {i18n.t("js.email_accounts.accounts.no_signature_preview")}
        </div>
      )}
    </div>
  )
}
